var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as PropTypes from 'prop-types';
import * as React from 'react';
import Icon from '../Icon/Icon';
import { customPropTypes, UIComponent, createShorthandFactory, commonPropTypes, } from '../../lib';
/**
 * A status graphically represents someone's or something's state.
 */
var Status = /** @class */ (function (_super) {
    __extends(Status, _super);
    function Status() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Status.prototype.renderComponent = function (_a) {
        var ElementType = _a.ElementType, classes = _a.classes, rest = _a.rest, variables = _a.variables, styles = _a.styles;
        var icon = this.props.icon;
        return (React.createElement(ElementType, __assign({}, rest, { className: classes.root }), Icon.create(icon, {
            defaultProps: {
                size: 'smallest',
                styles: styles.icon,
                variables: variables.icon,
                xSpacing: 'none',
            },
        })));
    };
    Status.className = 'ui-status';
    Status.displayName = 'Status';
    Status.propTypes = __assign({}, commonPropTypes.createCommon({
        children: false,
        content: false,
    }), { color: PropTypes.string, icon: customPropTypes.itemShorthand, size: PropTypes.number, state: PropTypes.oneOf(['success', 'info', 'warning', 'error', 'unknown']) });
    Status.defaultProps = {
        as: 'span',
        size: 10,
        state: 'unknown',
    };
    return Status;
}(UIComponent));
Status.create = createShorthandFactory(Status, 'state');
export default Status;
